module.exports = __webpack_public_path__ + "img/741.9a93a916.png";